import { Box } from "@primer/react";
import { useState } from "react";
import ConEmBoDoiCongAnPage from "./bodoi-congan";
import ConEmGiaoVienPage from "./cbcnv";

interface HocSinh {
    id: number;
    ho_ten: string;
    ma_hs: string;
    ma_tn: string;
    ngay_sinh: string;
    dm_gioitinh_id: number;
    gioi_tinh: string;
    ten_he: string;
    ten_lop: string;
    trang_thai: string;
}

interface Props {
    hocSinh: HocSinh;
    canEdit?: boolean;
}

const CanBoNhanVienLayout: React.FC<Props> = ({ hocSinh, canEdit = true }) => {
    const [selectedTab, setSelectedTab] = useState<"cbnv" | "congan" | "khac">("cbnv");

    return (
        <Box>
            {/* <UnderlineNav aria-label="tabs">
                <UnderlineNav.Item
                    icon={HomeIcon}
                    aria-current={selectedTab === "cbnv" ? "page" : undefined}
                    onClick={() => setSelectedTab("cbnv")}
                >
                    Cán bộ nhân viên
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={PeopleIcon}
                    aria-current={selectedTab === "congan" ? "page" : undefined}
                    onClick={() => setSelectedTab("congan")}
                >
                    Bộ đội, công an
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={FileBadgeIcon}
                    aria-current={selectedTab === "khac" ? "page" : undefined}
                    onClick={() => setSelectedTab("khac")}
                >
                    TH đặc biệt
                </UnderlineNav.Item>
            </UnderlineNav> */}
            <Box sx={{ display: "grid", gap: 3 }}>
                <ConEmGiaoVienPage hocSinh={hocSinh} canEdit={canEdit} />
                {/* <ConEmBoDoiCongAnPage hocSinh={hocSinh} is_th_dacbiet={false} /> */}
                <ConEmBoDoiCongAnPage hocSinh={hocSinh} is_th_dacbiet={true} canEdit={canEdit} />
                {/* {selectedTab === "cbnv" && <ConEmGiaoVienPage hocSinh={hocSinh} />}
                {selectedTab === "congan" && <ConEmBoDoiCongAnPage hocSinh={hocSinh} is_th_dacbiet={false} />}
                {selectedTab === "khac" && <ConEmBoDoiCongAnPage hocSinh={hocSinh} is_th_dacbiet={true} />} */}

            </Box>
        </Box>
    );
};

export default CanBoNhanVienLayout;
